import React from 'react';
import { ErrorFlag, type FlagProps } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type ExportErrorFlagProps = {
	id: string;
	errorTitle?: string | null;
	errorMessage?: string | null;
	onDismissed: () => void;
	actions?: FlagProps['actions'];
};

export const ExportErrorFlag = ({
	id,
	errorTitle,
	errorMessage,
	onDismissed,
	actions,
}: ExportErrorFlagProps) => {
	const { formatMessage } = useIntl();

	return (
		<ErrorFlag
			id={id}
			title={errorTitle || formatMessage(messages.exportErrorFlagDefaultTitle)}
			description={errorMessage || formatMessage(messages.exportErrorFlagDefaultDescription)}
			onDismissed={onDismissed}
			messageId="issue-navigator-action-export-issues.common.ui.export-error-flag.error-flag"
			messageType="transactional"
			actions={actions}
		/>
	);
};
